const fields = {
  config: { columns: 2 },
  fields: [
    {
      name: "id",
      column: 1,
      type:"unvisible"
    },
    {
      name: "phoneNumber",
      label: "Numer telefonu",
      column: 1,
      mandatory: true,
      type: "phone-number",

    },
    {
      name: "email",
      label: "Email",
      column: 2,
      type: "email",
    },
    {
      name: "name",
      label: "Imię",
      column: 1,
      mandatory: true,
    },
    {
      name: "surname",
      label: "Nazwisko",
      column: 2,
    },
  ],
};

export default fields;
